import { resolveStripePriceId } from "@/utils/stripe/price-env";


export const SILVER_MONTHLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_SILVER_MONTHLY_PRICE_ID,
  "price_1TlvGFGrgdPJmrXHTCpPaE4w",
);

export const GOLD_MONTHLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_GOLD_MONTHLY_PRICE_ID,
  "price_1TlvH5GrgdPJmrXHzHmDhTLl",
);

export const LIVE_DIAMOND_MONTHLY_PRICE_ID = "price_1TlvHaGrgdPJmrXHSN0S0olM";
export const LIVE_DIAMOND_MONTHLY_EXPERIMENT_PRICE_ID = "price_1TqyQoGrgdPJmrXHrLoPHRg6";
export const LIVE_DIAMOND_YEARLY_PRICE_ID = "price_1TmG5NGrgdPJmrXHjwAs0V2R";

export const DIAMOND_MONTHLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_DIAMOND_MONTHLY_PRICE_ID,
  LIVE_DIAMOND_MONTHLY_PRICE_ID,
);

export const DIAMOND_MONTHLY_EXPERIMENT_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_DIAMOND_MONTHLY_EXPERIMENT_PRICE_ID,
  LIVE_DIAMOND_MONTHLY_EXPERIMENT_PRICE_ID,
);

export const TIER_MONTHLY_PRICE_ID: Record<"silver" | "gold" | "diamond", string> = {
  silver: SILVER_MONTHLY_PRICE_ID,
  gold: GOLD_MONTHLY_PRICE_ID,
  diamond: DIAMOND_MONTHLY_PRICE_ID,
};

export const SILVER_YEARLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_SILVER_YEARLY_PRICE_ID,
  "price_1TmG4aGrgdPJmrXHzGv2foR2",
);

export const GOLD_YEARLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_GOLD_YEARLY_PRICE_ID,
  "price_1TmG51GrgdPJmrXH9kefbJlY",
);

export const DIAMOND_YEARLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_DIAMOND_YEARLY_PRICE_ID,
  LIVE_DIAMOND_YEARLY_PRICE_ID,
);

export const DIAMOND_PRODUCTION_PRICE_IDS_BY_PERIOD = {
  monthly: [LIVE_DIAMOND_MONTHLY_PRICE_ID, LIVE_DIAMOND_MONTHLY_EXPERIMENT_PRICE_ID],
  yearly: [LIVE_DIAMOND_YEARLY_PRICE_ID],
} as const;

export const DIAMOND_PRODUCTION_PRICE_IDS = [
  ...DIAMOND_PRODUCTION_PRICE_IDS_BY_PERIOD.monthly,
  ...DIAMOND_PRODUCTION_PRICE_IDS_BY_PERIOD.yearly,
];

export const TIER_YEARLY_PRICE_ID: Record<"silver" | "gold" | "diamond", string> = {
  silver: SILVER_YEARLY_PRICE_ID,
  gold: GOLD_YEARLY_PRICE_ID,
  diamond: DIAMOND_YEARLY_PRICE_ID,
};

export const ADDON_WHALE_WATCH_MONTHLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_WHALE_WATCH_MONTHLY_PRICE_ID,
  "price_1T6aY1GrgdPJmrXHzJQkoAXK",
);

export const ADDON_EV_SNIPER_MONTHLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_EV_SNIPER_MONTHLY_PRICE_ID,
  "price_1TmIDFGrgdPJmrXHTlV68CY1",
);

export const ADDON_EV_SNIPER_MONTHLY_EXPERIMENT_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_EV_SNIPER_MONTHLY_EXPERIMENT_PRICE_ID,
  "price_1TqyQoGrgdPJmrXH1VZcNtA2",
);

export const ADDON_VIP_DISCORD_MONTHLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_VIP_DISCORD_MONTHLY_PRICE_ID,
  "price_1U411aGrgdPJmrXHHtFOTJly",
);

export const ADDON_VIP_DISCORD_YEARLY_PRICE_ID = resolveStripePriceId(
  process.env.NEXT_PUBLIC_STRIPE_VIP_DISCORD_YEARLY_PRICE_ID,
  "price_1U411aGrgdPJmrXHeoPTFaTN",
);
